module.exports = __webpack_public_path__ + "img/banner-logo.ebcb0a48.png";